<template>
    <div
        class="cz2__steps-options__review"
        :class="[
            `cz2__steps--sb-type-${spellingBeeType}`,
            {
                'cz2__steps-options__review--two-pack': isTwoPack,
            },
        ]"
    >
        <template v-if="isSpellingBee && windowWidth >= 1024 && !isKiosk">
            <div class="cz2__steps-options__review-sb-container">
                <div class="cz2__steps-options__review-sb-container__toggles">
                    <div class="cz2__steps-options__review-sb-container__toggles__line" />

                    <sb-pop-view-toggle />
                </div>

                <div class="cz2__steps-options__review-sb-container__main">
                    <main-navigation
                        class="cz2__main-navigation-wrapper"
                        :light="true"
                    />

                    <div
                        ref="rendererPlaceholder"
                        class="cz2__renderer-placeholder"
                    />

                    <div class="cz2__renderer-placeholder-spacer" />
                </div>
            </div>
        </template>

        <template v-else-if="isSpellingBee && windowWidth < 1024 && !sKiosk">
            <div class="cz2__steps-options__review-sb-container">
                <div class="cz2__steps-options__review-sb-container__main">
                    <main-navigation
                        class="cz2__main-navigation-wrapper"
                        :light="true"
                    />

                    <sb-pop-view-toggle />

                    <div
                        ref="rendererPlaceholder"
                        class="cz2__renderer-placeholder"
                    />

                    <div class="cz2__renderer-placeholder-spacer" />
                </div>
            </div>
        </template>

        <template v-else-if="isSpellingBee && isKiosk">
            <div class="cz2__steps-options__review-sb-container">
                <div class="cz2__steps-options__review-sb-container__main">
                    <main-navigation
                        class="cz2__main-navigation-wrapper"
                        :light="true"
                    />

                    <div
                        ref="rendererPlaceholder"
                        class="cz2__renderer-placeholder"
                    />

                    <div class="cz2__renderer-placeholder-spacer" />

                    <sb-pop-view-toggle />
                </div>
            </div>
        </template>

        <template v-else>
            <div class="cz2__review--header">
                <funko-logos />

                <main-navigation class="cz2__main-navigation-wrapper" />

                <share-buttons
                    v-if="!isSpellingBee && isMobile && !isKiosk"
                    class="cz2__review-share-buttons"
                />
            </div>

            <div
                ref="rendererPlaceholder"
                class="cz2__renderer-placeholder"
            />

            <div class="cz2__renderer-placeholder-spacer" />

            <share-buttons
                v-if="!isSpellingBee && !isMobile && !isKiosk"
                class="cz2__review-share-buttons"
            />

            <pop-view-toggle
                v-if="!isKiosk"
                class="cz2__review-toggle-buttons"
            />
        </template>
    </div>
</template>

<style lang="scss">
    @import "../style/variables.scss";

    #cz2.cz2 {
        .cz2__steps-options__review {
            --steps-options-nav-height: 136px;

            pointer-events: auto;

            padding: 8px var(--layout-spacing);
            padding-bottom: var(--steps-options-nav-height);

            width: 100%;
            height: 100%;
            @include bg(gradientBlue);

            display: flex;
            flex-direction: column;
            align-items: center;

            .cz2__renderer-placeholder {
                margin-bottom: 20px;

                width: 100%;

                flex: 1;
            }

            .cz2__renderer-placeholder-spacer {
                height: 24px;
            }

            .cz2__review-toggle-buttons {
                margin-top: 24px;
            }

            .cz2__review--header {
                z-index: 1;
                width: 100%;
                display: grid;
                grid-template-columns: 1fr 3fr 1fr;
                align-items: flex-start;

                .cz2__funko-logos {
                    margin: 0;
                    padding: 0;
                    justify-self: flex-start;
                }

                .cz2__review-share-buttons {
                    align-self: center;
                    margin-left: 8px;
                }

                .cz2__main-navigation-wrapper {
                    justify-self: center;
                    align-self: center;

                    .cz2__main-navigation-button-content {
                        font-size: 22px;
                    }
                }
            }

            @include respond-above(md) {
                padding: 48px var(--layout-spacing) var(--steps-options-nav-height) var(--layout-spacing);

                padding: 24px 32px var(--steps-options-nav-height) 32px;

                .cz2__review--header {
                    grid-template-columns: 1fr 2fr 1fr;

                    .cz2__main-navigation-wrapper {
                        .cz2__main-navigation-button-content {
                            font-size: inherit;
                        }
                    }
                }

                .cz2__review-share-buttons,
                .cz2__review-toggle-buttons {
                    z-index: 1;
                    position: absolute;
                    top: 50%;
                    transform: translateY(-50%);
                }

                .cz2__review-share-buttons {
                    margin-left: 0;
                    left: 32px;
                }

                .cz2__review-toggle-buttons {
                    margin-top: 0;
                    right: 32px;
                }
            }

            @include respond-above(xl) {
                .cz2__steps-options__review--header {
                    .cz2__review-logo {
                        width: 212px;
                        height: 195px;
                    }
                }
            }
        }
    }

    #cz2.cz2.cz2__is-kiosk {
        .cz2__steps-options__review {
            .cz2__review--header {
                grid-template-columns: auto;
            }

            .cz2__funko-logo-link {
                display: none;
            }

            .cz2__main-navigation-button {
                margin-top: 111px;
            }

            .cz2__main-navigation-wrapper {
                width: 100%;
                display: flex;
                justify-content: center;
            }

            .cz2__review-views__copy {
                padding-top: 24px;
            }

            .cz2__renderer-placeholder-spacer {
                height: 260px;
            }
        }
    }

    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    //   ▗▄▄▖▗▄▄▖ ▗▄▄▄▖▗▖   ▗▖   ▗▄▄▄▖▗▖  ▗▖ ▗▄▄▖    ▗▄▄▖ ▗▄▄▄▖▗▄▄▄▖
    //  ▐▌   ▐▌ ▐▌▐▌   ▐▌   ▐▌     █  ▐▛▚▖▐▌▐▌       ▐▌ ▐▌▐▌   ▐▌
    //   ▝▀▚▖▐▛▀▘ ▐▛▀▀▘▐▌   ▐▌     █  ▐▌ ▝▜▌▐▌▝▜▌    ▐▛▀▚▖▐▛▀▀▘▐▛▀▀▘
    //  ▗▄▄▞▘▐▌   ▐▙▄▄▖▐▙▄▄▖▐▙▄▄▖▗▄█▄▖▐▌  ▐▌▝▚▄▞▘    ▐▙▄▞▘▐▙▄▄▖▐▙▄▄
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    #cz2.cz2.cz2__is-sb {
        .cz2__steps-options__review {
            position: absolute;

            .cz2__renderer-placeholder {
                flex: 1 1 0%;

                margin: 0;

                // Push up to free up space for 360 controls.
                margin-top: 0px;
                margin-bottom: 0px;

                @include respond-above-height(sm, medium) {
                    margin-top: -48px;
                    margin-bottom: 48px;
                }

                @include respond-above-height(lg, medium) {
                    margin-top: -68px;
                    margin-bottom: 95px;
                }

                @include respond-above-height(xl, medium) {
                    margin-top: -68px;
                    margin-bottom: 95px;
                }
            }

            &.cz2__steps-options__review--two-pack {
                .cz2__renderer-placeholder {
                    flex: 1 1 0%;

                    margin: 0;

                    // Push up to free up space for 360 controls.
                    margin-top: 0px;
                    margin-bottom: -48px;

                    @include respond-above-height(sm, medium) {
                        margin-top: -48px;
                        margin-bottom: 48px;
                    }

                    @include respond-above-height(lg, medium) {
                        margin-top: -68px;
                        margin-bottom: 95px;
                    }

                    @include respond-above-height(xl, medium) {
                        margin-top: 0px;
                        margin-bottom: 0px;
                    }
                }
            }

            .cz2__review-logo {
                display: none;
            }

            .cz2__main-navigation-wrapper {
                z-index: 1;

                margin-bottom: 10px;

                .cz2__main-navigation-button-content-wrapper {
                    box-shadow: none;

                    &:before {
                        background: #fff !important;
                    }

                    .cz2__main-navigation-button-content__sb-chevron {
                        position: relative;

                        right: 0;
                    }
                }

                .cz2__main-navigation-button-title-wrapper {
                    color: #112344;
                }
            }

            .cz2__steps-options__review-sb-container {
                display: flex;

                width: 100%;
                height: 100%;

                @include respond-above(lg) {
                    padding-left: 50px;
                    padding-right: 50px;
                }
            }

            .cz2__steps-options__review-sb-container__toggles {
                position: relative;

                flex: 0 0 auto;

                width: 25%;
                min-width: 280px;
            }

            .cz2__steps-options__review-sb-container__toggles__line {
                position: absolute;

                right: -10px;
                top: 80px;
                bottom: 80px;

                width: 1px;

                background: #8E403F;

                &:before {
                    content: '';

                    position: absolute;

                    top: 0;
                    left: -3px;

                    width: 7px;
                    height: 7px;

                    background: #8E403F;

                    transform: rotate(45deg);
                }

                &:after {
                    content: '';

                    position: absolute;

                    bottom: 0;
                    left: -3px;

                    width: 7px;
                    height: 7px;

                    background: #8E403F;

                    transform: rotate(45deg);
                }
            }

            .cz2__steps-options__review-sb-container__main {
                flex: 1 1 0;

                display: flex;
                flex-direction: column;
                align-items: center;

                padding-top: 0px;
                padding-bottom: var(--steps-options-nav-height);

                @include respond-above(lg) {
                    padding-top: 35px;

                    padding-bottom: var(--steps-options-nav-height);
                }

                @include respond-above-height(xl, medium) {
                    padding-top: 60px;
                }
            }
        }

        .cz2__steps-options__review, .cz2__steps-options__checkout-gradient {
            width: 100%;
            height: 100%;
            padding: 48px 24px;

            @include respond-above(lg) {
                padding: 48px;
            }

            background-size: 50%;
            background-position: center;
            background-repeat: repeat;

            &.cz2__steps--sb-type-none {
                background-image: url('../assets/images/branded/sb-final/SB-Background-Pattern-3_D_Attach-Pack-Image-G@2x.jpg');
                @include respond-above(sm) {
                    background-image: url('../assets/images/branded/sb-final/SB-Background-Pattern-3_D_Attach-Pack-Image-G@2x.jpg');
                }
            }

            &.cz2__steps--sb-type-G {
                background-image: url('../assets/images/branded/sb-final/SB-Background-Pattern-3_D_Attach-Pack-Image-G@2x.jpg');
                @include respond-above(sm) {
                    background-image: url('../assets/images/branded/sb-final/SB-Background-Pattern-3_D_Attach-Pack-Image-G@2x.jpg');
                }
            }

            &.cz2__steps--sb-type-H {
                background-image: url('../assets/images/branded/sb-final/SB-Background-Pattern-3_D_Attach-Pack-Image-H@2x.jpg');
                @include respond-above(sm) {
                    background-image: url('../assets/images/branded/sb-final/SB-Background-Pattern-3_D_Attach-Pack-Image-H@2x.jpg');
                }
            }

            &.cz2__steps--sb-type-S {
                background-image: url('../assets/images/branded/sb-final/SB-Background-Pattern-3_D_Attach-Pack-Image-S@2x.jpg');
                @include respond-above(sm) {
                    background-image: url('../assets/images/branded/sb-final/SB-Background-Pattern-3_D_Attach-Pack-Image-S@2x.jpg');
                }
            }

            &.cz2__steps--sb-type-R {
                background-image: url('../assets/images/branded/sb-final/SB-Background-Pattern-3_D_Attach-Pack-Image-R@2x.jpg');
                @include respond-above(sm) {
                    background-image: url('../assets/images/branded/sb-final/SB-Background-Pattern-3_D_Attach-Pack-Image-R@2x.jpg');
                }
            }

            background-size: cover !important;
            background-color: transparent;

            border-image-source: url('../assets/images/branded/sb-final/SB-Border 3_M@2x.webp');

            border-width: 40px;
            border-image-width: 40px;
            border-image-slice: 80 fill;
            border-image-repeat: stretch;

            @include respond-above(lg) {
                border-image-source: url('../assets/images/branded/sb-final/SB-Border 3_D@2x.webp');
                height: 100%;
                width: 100%;
                border-width: 70px;
                border-image-width: 70px;
                border-image-slice: 140 fill;
                border-image-repeat: stretch;
            }
        }

        .cz2__steps-options__review + .cz2__steps-options__navigation {
            margin-bottom: 40px;
            width: 100%;
            padding-left: 40px;
            padding-right: 40px;

            @include respond-above(lg) {
                padding-left: clamp(280px, (100% - 200px) * 0.25 + 100px, 100%);
                margin-bottom: 80px;

                button {
                    width: 100%;
                    max-width: 450px;
                }
            }

            @include respond-above(xl) {
                padding-left: clamp(280px, (100% - 200px) * 0.25 + 50px, 100%);
            }
        }
    }

    #cz2.cz2.cz2__is-sb.cz2__is-kiosk {
        .cz2__steps-options__review {
            height: calc(100% - var(--steps-options-nav-height-sb));

            padding: 90px 0 130px;

            .cz2__main-navigation-button {
                margin-top: 0px;
            }

            .cz2__steps-options__review-sb-container__main {
                padding-bottom: 0;
            }

            .cz2__renderer-placeholder-spacer {
                height: 30px;
            }
        }
    }
</style>

<script>
    import axios from 'axios';

    import MainNavigation from './MainNavigation.vue';
    import PopViewToggle from './PopViewToggle.vue';
    import SbPopViewToggle from './SbPopViewToggle.vue';
    import FunkoLogos from './FunkoLogos.vue';
    import ShareButtons from './ShareButtons.vue';

    export default {
        components: {
            MainNavigation,
            PopViewToggle,
            SbPopViewToggle,
            FunkoLogos,
            ShareButtons,
        },

        computed: {
            viewController() {
                return this.$store.state.customizer.viewController;
            },

            options() {
                return this.$store.state.customizer.options;
            },

            boxName() {
                return this.$store.state.customizer.boxName;
            },

            isTwoPack() {
                return this.$store.getters.isTwoPack;
            },

            isKiosk() {
                return this.options && this.options.isKiosk;
            },

            isSpellingBee() {
                return this.$store.state.isSpellingBee;
            },

            spellingBeeType() {
                return this.$store.state.spellingBeeType ?? 'none';
            },

            windowWidth() {
                return this.$store.state.windowWidth;
            },

            noSavePreviews() {
                return this.$store.state.customizer.noSavePreviews;
            },

            isMobile() {
                return this.$store.state.customizer.isMobile;
            },
        },

        mounted() {
            this.updateNavigation();

            // this.$store.dispatch('updateBoxName', this.boxName);

            // Since there is a view transition between the Name and Looks Good step, we need to
            // grab icon snapshots when it is safe to do so - when nothing animates on the screen.
            // So, we first render icons, and then animate the view.

            // Grab preview snapshots.

            // Is the camera still loading? Switch to the step right away.
            this.emitter.$emit('isCameraLoading', (isLoading) => {
                if (isLoading) {
                    this.$store.dispatch('setPreferredView', this.isTwoPack ? 'BoxFarPack' : 'BoxFar');
                } else {
                    this.getPreviews().then(() => {
                        this.$store.dispatch('setPreferredView', this.isTwoPack ? 'BoxFarPack' : 'BoxFar');
                    });
                }
            });

            this.emitter.$on('cameraLoading', this.cameraLoading);

            this.emitter.$emit('setRendererPlaceholder', {
                owner: 'review',
                placeholder: this.$refs.rendererPlaceholder,
            });
        },

        beforeDestroy() {
            this.emitter.$off('cameraLoading', this.cameraLoading);

            this.emitter.$emit('setRendererPlaceholder', {
                owner: 'review',
            });
        },

        methods: {
            updateNavigation() {
                if (this.isKiosk) {
                    this.$emit('updateNavigation', {
                        hasBack: true,
                        canGoBack: true,
                        hasNext: true,
                        canGoNext: true,
                        nextSpecial: 'Contact',
                        previousSpecial: 'Name',
                    });
                } else {
                    this.$emit('updateNavigation', {
                        hasBack: true,
                        canGoBack: true,
                        hasNext: true,
                        canGoNext: true,
                        nextSpecial: 'Checkout',
                        previousSpecial: 'Name',
                    });
                }
            },

            async getPreviews() {
                if (this.noSavePreviews) {
                    return;
                }

                const popImage = await this.$store.dispatch('snapshot', this.isTwoPack ? 'SnapshotPopPack' : 'SnapshotPop');
                const boxImage = await this.$store.dispatch('snapshot', this.isTwoPack ? 'SnapshotBoxPack' : 'SnapshotBox');

                this.$store.dispatch('setPreviewImages', {
                    popPreviewImage: popImage,
                    boxPreviewImage: boxImage,
                });

                // _After_ we got previews, save the recipe.
                this.saveRecipe();
            },

            saveRecipe() {
                this.$store.dispatch('customizerDone', {
                    type: 'cart',
                    noBusy: true,
                    noVariants: true,
                    saveTemporary: true,
                }).then((recipeData) => {
                    this.$store.dispatch('setSavedRecipe', recipeData);

                    this.recordAbandonedCart(recipeData);
                });
            },

            recordAbandonedCart(recipeData) {
                if (!this.isKiosk) {
                    if (this.viewController.blueprint.custom['fun-save-abandoned'] === 'true') {
                        // Find preview.
                        const preview = recipeData.recipe.views.find((x) => x.code === 'Preview');

                        if (preview) {
                            const png = `https:${preview.previewPng}`;

                            const formData = new URLSearchParams();

                            let name = '';

                            if (this.$store.getters.isTwoPack) {
                                name = Object.values(this.$store.state.customizer.boxNamesByController).join(' & ');
                            } else {
                                name = this.$store.state.customizer.boxName;
                            }

                            formData.append('name', name);
                            formData.append('imageURL', png);
                            formData.append('recipeId', recipeData.recipe.id);

                            // Send POST request with form data
                            let targetUrl = '/on/demandware.store/Sites-FunkoUS-Site/en_US/Customizer-FireAbandonmentEvent';

                            if (this.$store.state.options.abandonedCartEndpoint) {
                                targetUrl = this.$store.state.options.abandonedCartEndpoint;
                            }

                            if (this.$store.state.options.abandonmentEventEndpoint) {
                                targetUrl = this.$store.state.options.abandonmentEventEndpoint;
                            }

                            axios.post(targetUrl, formData, {
                                headers: {
                                    'Content-Type': 'application/x-www-form-urlencoded',
                                },
                            });
                        }
                    }
                }
            },

            cameraLoading(loading) {
                if (!loading) {
                    // If camera finished loading while we were on this step, recapture the screenshots.
                    this.getPreviews().then(() => {
                        // Don't care what happens when it finishes.
                    });
                }
            },
        },
    };
</script>
